import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { ToastStackWithDismissAll } from '@/components/ui/ToastStackWithDismissAll';
import { StepProvider } from '@/context/StepContext';
import { QueryProvider } from '@/context/QueryProvider';
import { ModalProvider } from '@/context/ModalContext';
import { GlobalModal } from '@/components/ui/GlobalModal';

function GoogleAnalyticsTracker() {
	// `useLocation()` deveria sempre estar disponível dentro de um `<Router>`,
	// mas em alguns ambientes a app pode renderizar fora do contexto.
	// Para não quebrar a aplicação, fazemos fallback para `window.location`.
	let pathname = '';
	try {
		pathname = useLocation().pathname;
	} catch {
		pathname =
			typeof window !== 'undefined' ? window.location.pathname : '';
	}

	useEffect(() => {
		if (!pathname) return;
		ReactGA.send({ hitType: 'pageview', page: pathname });
	}, [pathname]);

	return null;
}

export function RootLayout() {
	return (
		<QueryProvider>
			<ModalProvider>
				<StepProvider>
					<GoogleAnalyticsTracker />
					<Outlet />
					<ToastStackWithDismissAll
						position="top-right"
						autoClose={10000}
						hideProgressBar={false}
						style={{ zIndex: 99999 }}
					/>
					<GlobalModal />
				</StepProvider>
			</ModalProvider>
		</QueryProvider>
	);
}
